import { useState } from "react";
import { useUser } from "../contexts/UserContext";
import { useNavigate, useLocation } from "react-router-dom";

import Background_grey from "../assets/icons/Background_grey.svg";
import Help_icon from "../assets/icons/help.svg";
import User_icon from "../assets/icons/User_Account_Gold.svg";
import Config from "../config";

function Nav() {
    const [isLogOutOpen, setLogOutOpen] = useState(false);
    const { user, logout } = useUser();
    const navigate = useNavigate();
    const location = useLocation();

    const toggleLogOut = () => {
        setLogOutOpen((prev) => !prev);
    };

    const handleLogout = () => {
        logout()
            .then(() => {
                navigate("/");
                setLogOutOpen(false);
            })
            .catch((err) => console.error("Logout failed:", err));
    };

    const goToHomePage = () => {
        navigate("/landing");
    };

    // Condition to hide User_icon in LoginPage and GetAnAccount
    const hideUserIcon =
        location.pathname === "/" || location.pathname === "/get-account";
    const hasSites = Array.isArray(Config.sites) && Config.sites.length > 0;
    const companyLogo = Config.companyLogo;

    const goToSelectApp = () => {
        navigate("/select-app");
    };

    return (
        <nav className="Main-nav">
            <ul className="nav-items">
                <li className="nav-logo">
                    <img
                        src={Background_grey}
                        alt="Logo de Mincka"
                        className="nav-img"
                        onClick={goToHomePage}
                    />
                </li>
                <div className="nav-right">
                    {companyLogo && !hideUserIcon && (
                        <img
                            src={companyLogo}
                            alt="Company Logo"
                            className="nav-company-logo"
                        />
                    )}
                    {hasSites && !hideUserIcon && user && (
                        <button className="select-site" onClick={goToSelectApp}>
                            Select Facility
                        </button>
                    )}
                    <img src={Help_icon} alt="Help Icon" className="icon-img" />
                    {!hideUserIcon && user && (
                        <img
                            src={User_icon}
                            alt="User Icon"
                            className="icon-img"
                            onClick={toggleLogOut}
                            style={{ cursor: "pointer" }}
                        />
                    )}
                    {isLogOutOpen && user && (
                        <div className="log-out">
                            <p>
                                <strong>Name:</strong> {user.name}
                            </p>
                            <p>
                                <strong>Email:</strong> {user.email}
                            </p>
                            <div>
                                <button onClick={handleLogout}>Log Out</button>
                            </div>
                        </div>
                    )}
                </div>
            </ul>
        </nav>
    );
}

export default Nav;
